export default function () {
  return readonly({
    /**
     * Main layout, including all elements/components. Basically the top level container that
     * separates the navigation part of the app from the rest (auth, etc.)
     */
    mainLayoutId: "poly-main-layout",
    mainAgentId: "poly-main-agent",
    /**
     * The collection view is the main view of your folder, search, or collection of files
     */
    collectionScrollContainerId: "poly-collection-scroll-container",
    collectionViewTopBarPadding: 44,
    collectionTreeChevronClass: "poly-tree-chevron",
    collectionColumnDraggerClass: "poly-column-dragger",
    collectionTableDraggerClass: "poly-table-dragger",

    collectionFooterOfflineToastId: "poly-collection-footer-offline-toast",

    /**
     * This if from the 'perfect-scrollbar' library. We can't use the wrapper class because
     * it wraps the whole element. Instead we have to use just this scrollbar container
     */
    scrollbarClass: "os-scrollbar",
    peekBackgroundId: "poly-peek-background",
    peekWindowId: "poly-peek-window",
    /**
     * This is used to help our transform go from preview image to full screen
     * preview, so this needs to be set for each thumbnail depending on which is
     * the current one.
     */
    thumbnailPreviewImage: "poly-thumbnail-preview-image",

    /**
     * Apply this to any element where we want the item to cause fade-on-dwell to be
     * ignored.
     */
    previewNoFade: "poly-preview-no-fade-on-dwell",

    imageRendererContainerClass: "poly-image-preview-container",
    /**
     * This class is used to ignore gesture events that would otherwise be based on "clicking
     * out" of something, e.g. cancelling a file selection
     */
    navIgnoreMainViewGestures: "poly-nav-ignore-main-view-gestures",
    navTauriDragRegionClass: "poly-nav-tauri-drag-region",

    /** The attribute for a <... data-file-id > element */
    fileIdAttr: "file-id",
    /** The attribute for a <... data-search-id > element */
    searchIdAttr: "search-id",
    /** The attribute for a <... data-conversation-id > element */
    conversationIdAttr: "conversation-id",
    /** The attribute for a <... data-file-id > element */
    sharedDriveIdAttr: "shared-drive-id",
    /** The attribute for a <... data-element-id > element, used for uniquely identification */
    elementIdAttr: "element-id",
    /** The folder id corresponding to each column in column view */
    columnViewFolderIdAttr: "column-view-folder-id",
    columnViewFolderIdProp: "columnViewFolderId",

    panelId: "poly-panel",
    panelDraggerId: "poly-panel-dragger",
    panelWaterfallId: "poly-panel-waterfall",
    panelAgentId: "poly-panel-agent",
    panelChatsId: "poly-panel-chats",
    panelOutlineId: "poly-panel-outline",

    navOmniBarId: "poly-nav-omni",
    navSearchId: "poly-nav-search",

    sidebarId: "poly-sidebar",
    sidebarRootsId: "poly-sidebar-roots",
    sidebarFavoritesId: "poly-sidebar-favorites",
    sidebarSharedDrivesId: "poly-sidebar-shared-drives",
    sidebarDraggerId: "poly-sidebar-dragger",
    sidebarChevronClass: "poly-sidebar-chevron",

    contextMenuId: "poly-context-menu",

    searchButton: "poly-search-button",

    panelAgentInputId: "panel-agent-input",

    panelCommentInputId: "panel-comment-input",
    panelCommentClass: "poly-panel-comment",

    /** If we are editing a property, add this class to the container */
    propertyEditorClass: "poly-property-editor",

    /** The key used for the "unknown" group name when grouping files into sections */
    UNKNOWN_COLLECTION_GROUP_ID: "unknown",
  })
}
